<template>
	<div class="text-center">
		<v-dialog
				:value="isSchedulesPopup"
				@click:outside="onClose"
				width="800"
		>
			<v-card>
				<v-card-title class="headline lighten-2">
					<div class="actionHeader">
						<span>View files</span>
						<div class="actionHeader_right">
							<v-btn
									icon
									fab
									x-small
									@click="onClose"
							>
								<v-icon>mdi-close</v-icon>
							</v-btn>
						</div>
					</div>
				</v-card-title>
				<v-container>
					<v-row>
						<v-col>
							<v-data-table
									:headers="headers"
									:items="filesList"
									class="safety-calendar invoice-table schedulesPopup"
									hide-default-footer
									hide-default-header
									hide-default-body
									disable-pagination
							>
								<template v-slot:header="{ props: { headers } }">
									<thead class="v-data-table-header">
									<tr>
										<th
												v-for="(item, index) in headers"
												:key="index"
												class="text-start sortable position-relative"
												:id="'container-'+item.value"
										>
											<span>{{ item.text }}</span>
										</th>
										<th width="20"></th>
									</tr>
									</thead>
								</template>
								<template v-slot:body="{ items }">
									<tbody>
									<template v-for="(item) in items">
										<tr :key="item.file">
											<td>{{ item.load_id }}</td>
											<td>{{ item.name }}</td>
											<td>{{ item['type'] }}</td>
											<td>
												<v-btn @click="onViewFile(item.file)" color="green" icon fab x-small>
													<v-icon>visibility</v-icon>
												</v-btn>
											</td>
										</tr>
									</template>
									</tbody>
								</template>
							</v-data-table>
						</v-col>
					</v-row>
				</v-container>
			</v-card>

		</v-dialog>
	</div>
</template>

<script>
export default {
	name: "SchedulesPopup",
	props: {
		filesList: Array,
		isSchedulesPopup: Boolean
	},
	computed: {
		headers() {
			return [
				{ text: "Load", value: "create_at", func: false },
				{ text: "File name", value: "employee", func: false },
				{ text: "File type", value: "notes", func: false },
			];
		},
	},
	methods: {
		onClose() {
			this.$emit('updateClose');
		},
		onViewFile(file) {
			this.$emit('updateFile', file);
		}
	}
};
</script>

<style scoped lang="scss">
.actionHeader {
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
}
</style>
<style lang="scss">
.safety-calendar.invoice-table.schedulesPopup .v-data-table__wrapper {
	min-height: initial;
}
</style>
